import BaseSelectBox from 'components/atoms/base-select-box';
import { useMemo, type FC } from 'react';
import { modulesDataSource } from 'infrastructure/data-sources/modules';

import type { ModulesItem } from 'infrastructure/data-sources/modules';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { ModuleType } from 'infrastructure/enums';

type Options = IBaseSelectBoxOption<ModulesItem['id'], ModulesItem>[];

interface ModulesSelectBoxProps
  extends Omit<IBaseSelectBoxProps<ModulesItem['id']>, 'options'> {
  withNone?: boolean;
  excludeModules?: ModuleType[];
}

export const ModulesSelectBox: FC<ModulesSelectBoxProps> = (props) => {
  const { withNone = true, excludeModules } = props;
  const dataSource = useMemo(
    () => modulesDataSource(withNone, excludeModules),
    [withNone, excludeModules],
  );

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};
